import { CopyOutlined } from '@ant-design/icons';
import { App } from 'antd';
import { memo, useEffect, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';

interface CredentialsConsumerProps {
  id: string;
}

export const ConsumerId = memo(({ id }: CredentialsConsumerProps) => {
  const [isSuccess, setSuccess] = useState(false);
  const { message } = App.useApp();

  useEffect(
    () =>
      void (isSuccess && message.success('Consumer ID was successfully copied', () => setSuccess(false)), [isSuccess]),
  );

  return (
    <CopyToClipboard text={id} onCopy={() => setSuccess(true)}>
      <span style={{ cursor: 'pointer' }}>
        {id} <CopyOutlined />
      </span>
    </CopyToClipboard>
  );
});
